const customBarOptions = function customBarOptions() {
  return {
    title: {
      show: true,
      textStyle: {
        color: "#888",
        fontSize: 16,
        fontWeight: 'normal',
      },
      text: "暂无数据",
      left: "center",
      top: "275",
    },
    color: ['#02A9F1', '#FFAE00'],
    tooltip: {
      trigger: 'axis',
      backgroundColor: "#fff",
      textStyle: {
        color: "#FFAE00",
      },
      padding: [15, 30],
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'none', // 默认为直线，可选为：'line' | 'shadow'
      },
      extraCssText: 'box-shadow:0px 6px 13px 0px rgba(65,140,231,0.18);text-align:center;',
      formatter(params) {
        return `新顾客${params[0].data}人<br>老顾客${params[1].data}人`;
      },
    },
    dataZoom: {
      type: 'slider',
      realtime: true, // 拖动滚动条时是否动态的更新图表数据
      height: 20, // 滚动条高度
      startValue: 0, // 数据窗口范围的起始数值
      endValue: 25,
      show: true,
      handleSize: 0, // 滑动条的 左右2个滑动条的大小
      zoomLock: true,
      bottom: 30, // 下面的距离
      borderColor: "rgba(132,205,149,0.2)",
      fillerColor: 'rgba(233, 233, 233, 1)',
      showDataShadow: false, // 是否显示数据阴影 默认auto
      showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
      borderRadius: 5,
      filterMode: 'filter',
      // backgroundColor: '#33384b', // 两边未选中的滑动条区域的颜色
    },
    grid: {
      left: '1%',
      right: '1%',
      bottom: '6%',
      top: "2%",
      containLabel: true,
    },
    xAxis: [{
      show: true,
      type: 'category',
      offset: 25,
      data: [],
      axisTick: {
        alignWithLabel: true,
      },
    }],
    yAxis: [{
      type: 'value',
      offset: 15,
    }],
    series: [
      {
        type: 'bar',
        stack: '顾客人数',
        barWidth: '15px',
        itemStyle: {
          emphasis: { color: '#008de7' }, // 鼠标滑过柱子颜色变化
        },
        data: [],
      },
      {
        type: 'bar',
        stack: '顾客人数',
        barWidth: '15px',
        itemStyle: {
          emphasis: { color: '#ff9600' }, // 鼠标滑过柱子颜色变化
        },
        data: [],
      },
    ],
  };
};

export default customBarOptions;
